// // reviews.js

// import initReviewsSwiper from "../components/reviewsSwiper";
// import initReviewsVideoSwiper from "../components/reviewsSwiperVideo";
// import getReviews from "./getReviews";
// import getReviewsVideo from "./getReviewsVideo";

// export default function reviewsInit() {
//   // Получаем элементы
//   const videoReviewsBtn = document.getElementById('video-reviews');
//   const textReviewsBtn = document.getElementById('text-reviews');
//   const videoSlider = document.querySelector(".reviews__slider2");
//   const textSlider = document.querySelector(".reviews__slider");

//   // Функция для переключения слайдеров
//   function switchToVideoReviews() {
//     console.log(1);
//     textSlider.style.display = "none";

//     const textNavBtns = [
//       document.querySelector(".reviews-button-next"),
//       document.querySelector(".reviews-button-prev"),
//     ];
//     const videoNavBtns = [
//       document.querySelector(".reviews2-button-next"),
//       document.querySelector(".reviews2-button-prev"),
//     ];

//     if (textNavBtns.length) {
//       textNavBtns.forEach((btn) => {
//         btn.style.display = "none";
//       });
//     }
//     if (videoNavBtns.length) {
//       videoNavBtns.forEach((btn) => {
//         btn.style.display = "";
//       });
//     }

//     videoReviewsBtn.classList.add("active");
//     textReviewsBtn.classList.remove("active");
//     videoSlider.style.display = "block";

//     if (window.videoSwiper) {
//       setTimeout(() => window.videoSwiper.update(), 100);
//     } else {
//       getReviewsVideo().then(() => {
//         window.videoSwiper = initReviewsVideoSwiper();
//       });
//     }
//   }

//   function switchToTextReviews() {
//     if (videoSlider) {
//       videoSlider.style.display = "none";

//       const videoNavBtns = [
//         document.querySelector(".reviews2-button-next"),
//         document.querySelector(".reviews2-button-prev"),
//       ];

//       if (videoNavBtns.length) {
//         videoNavBtns.forEach((btn) => {
//           btn.style.display = "none";
//         });
//       }

//       console.log(videoReviewsBtn);

//       videoReviewsBtn.classList.remove("active");
//     }

//     const textNavBtns = [
//       document.querySelector(".reviews-button-next"),
//       document.querySelector(".reviews-button-prev"),
//     ];

//     if (textNavBtns.length) {
//       textNavBtns.forEach((btn) => {
//         btn.style.display = "";
//       });
//     }

//     if (textReviewsBtn) {
//       textReviewsBtn.classList.add("active");
//       console.log(textReviewsBtn);
//     }


//     textSlider.style.display = "block";
//     if (window.textSwiper) {
//       setTimeout(() => window.textSwiper.update(), 100);
//     } else {
//       // getReviews().then(() => {
//         window.textSwiper = initReviewsSwiper();
//       // });
//     }
//   }

//   // Добавляем обработчики кликов
//   if (videoReviewsBtn) {
//     videoReviewsBtn.addEventListener("click", switchToVideoReviews);
//   }

//   if (textReviewsBtn) {
//     textReviewsBtn.addEventListener("click", switchToTextReviews);
//   }

//   // Устанавливаем начальное состояние (показываем текстовые отзывы)
//   switchToTextReviews();
// }


// reviews.js

import initReviewsSwiper from "../components/reviewsSwiper";
import initReviewsVideoSwiper from "../components/reviewsSwiperVideo";
import getReviews from "./getReviews";
import getReviewsVideo from "./getReviewsVideo";

export default function reviewsInit() {
  // Получаем элементы
  const videoReviewsBtn = document.getElementById('video-reviews');
  const textReviewsBtn = document.getElementById('text-reviews');
  const videoSlider = document.querySelector(".reviews__slider2");
  const textSlider = document.querySelector(".reviews__slider");

  // Функция для переключения на видео-отзывы
  function switchToVideoReviews() {
    // console.log('Переключение на видео-отзывы');
    
    // Скрываем текстовый слайдер
    if (textSlider) {
      textSlider.style.display = "none";
    }

    // Прячем кнопки навигации текстового слайдера
    const textNavBtns = document.querySelectorAll(".reviews-button-next, .reviews-button-prev");
    textNavBtns.forEach((btn) => {
      btn.style.display = "none";
    });

    // Показываем кнопки навигации видео-слайдера
    const videoNavBtns = document.querySelectorAll(".reviews2-button-next, .reviews2-button-prev");
    videoNavBtns.forEach((btn) => {
      btn.style.display = "";
    });

    // Переключаем активные классы кнопок
    if (videoReviewsBtn) {
      videoReviewsBtn.classList.add("active");
    }
    if (textReviewsBtn) {
      textReviewsBtn.classList.remove("active");
    }

    // Показываем видео-слайдер
    if (videoSlider) {
      videoSlider.style.display = "block";
    }

    // Инициализируем или обновляем видео-слайдер
    if (window.videoSwiper) {
      setTimeout(() => window.videoSwiper.update(), 100);
    } else {
      getReviewsVideo().then(() => {
        window.videoSwiper = initReviewsVideoSwiper();
      });
    }
  }

  // Функция для переключения на текстовые отзывы
  function switchToTextReviews() {
    // console.log('Переключение на текстовые отзывы');
    
    // Скрываем видео-слайдер
    if (videoSlider) {
      videoSlider.style.display = "none";
    }

    // Прячем кнопки навигации видео-слайдера
    const videoNavBtns = document.querySelectorAll(".reviews2-button-next, .reviews2-button-prev");
    videoNavBtns.forEach((btn) => {
      btn.style.display = "none";
    });

    // Показываем кнопки навигации текстового слайдера
    const textNavBtns = document.querySelectorAll(".reviews-button-next, .reviews-button-prev");
    textNavBtns.forEach((btn) => {
      btn.style.display = "";
    });

    // Переключаем активные классы кнопок
    if (textReviewsBtn) {
      textReviewsBtn.classList.add("active");
    }
    if (videoReviewsBtn) {
      videoReviewsBtn.classList.remove("active");
    }

    // Показываем текстовый слайдер
    if (textSlider) {
      textSlider.style.display = "block";
    }

    // Инициализируем или обновляем текстовый слайдер
    if (window.textSwiper) {
      setTimeout(() => window.textSwiper.update(), 100);
    } else {
      // getReviews().then(() => {
        window.textSwiper = initReviewsSwiper();
      // });
    }
  }

  // Добавляем обработчики кликов
  if (videoReviewsBtn) {
    videoReviewsBtn.addEventListener("click", switchToVideoReviews);
  }

  if (textReviewsBtn) {
    textReviewsBtn.addEventListener("click", switchToTextReviews);
  }

  // Устанавливаем начальное состояние (показываем текстовые отзывы)
  // Небольшая задержка для корректной инициализации
  setTimeout(() => {
    switchToTextReviews();
  }, 0);
}